// Name formatting utilities

/**
 * Formats name to proper case, handling spaces and hyphens
 */
export const formatName = (name: string | undefined | null): string => {
  if (!name) return ''

  return name
    .trim()
    .toLowerCase()
    .split(/(\s+|-)/) // Split on spaces/hyphens, keeping separators
    .map((part) => {
      if (part === ' ' || part === '-' || part === '') return part
      // Capitalize first letter of each word
      return part.charAt(0).toUpperCase() + part.slice(1)
    })
    .join('')
}
